import { httpClient } from '@/lib/http-client'
import { type PagedRequest, buildPagedParams } from '@/shared/types'

export const auditApi = {
    getAll: (params?: PagedRequest & { action?: string; entity_type?: string; user_id?: string }) => {
        const pagedParams = Object.fromEntries(buildPagedParams(params))
        const extra: Record<string, string> = {}
        if (params?.action) extra.action = params.action
        if (params?.entity_type) extra.entity_type = params.entity_type
        if (params?.user_id) extra.user_id = params.user_id
        return httpClient.get('/audit', { params: { ...pagedParams, ...extra } })
    },
    getEntry: (id: string) => httpClient.get(`/audit/${id}`),
    getStats: () => httpClient.get('/audit/stats'),
}
